import React from 'react';
import PropTypes from 'prop-types';
import { Paper, List, Subheader, Toggle } from 'material-ui';
import style from '../../../styles/styles';
import styles from './OpenExploreSetting.css';
import Loading from '../../common/Loading/Loading';
import withTranslation from '../../../hoc/withTranslation';

class OpenExploreSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func,
    };

    static defaultProps = {
        app: null,
        loading: false,
    };

    handleToggledSearchInDescription = (event, isInputChecked) => {
        this.props.editConfiguration('search_in_description', isInputChecked);
    };
    render() {
        const {
            loading,
            app
        } = this.props;
        let content;
        if (loading) {
            content = <Loading paper={false} />;
        } else {
            content = <div>
                <Toggle
                    style={styles.toggle}
                    label={this.props.t('settings_page.search_in_description')}
                    toggled={app.configurations.search_in_description}
                    labelPosition="right"
                    onToggle={this.handleToggledSearchInDescription}
                />
            </div>;
        }
        return <Paper>
            <List>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('module.open_explore.name')}
                </Subheader>

                <div style={style.paper}>
                    {content}
                </div>
            </List>
        </Paper>;
    }
}

export default withTranslation(OpenExploreSetting);



// WEBPACK FOOTER //
// src/components/common/OpenExploreSetting/OpenExploreSetting.js